// test2279
(2279 && 0);
